export const HEADER_ALIGN = 'center';
export const DEFAULT_CELL_ALIGN = 'left';

export const monthMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export const NO_RESULT_TEXT = 'No results for selected filters';
